import React from 'react';

const ModalDialog = ({
  id,
  aberto,
  setAberto,
  titulo,
  children,
  dialogClassName,
  opcaoFechar = true,
}) => {
  React.useEffect(() => {
    const modal = document.getElementById(`${id}`);

    if (aberto) {
      //modal.addEventListener('click', cliqueForaListener);
      document.body.addEventListener('keydown', listener);
      modal.showModal();
    } else {
      //modal.removeEventListener('click', cliqueForaListener);
      document.body.removeEventListener('keydown', listener);
      modal.close();
    }
  }, [aberto]);

  var listener = function (event) {
    if (event.key === 'Escape') {
      setAberto(false);
    }
  };

  var cliqueForaListener = function (event) {
    if (!event.target.closest('dialog > div')) {
      setAberto(false);
    }
  };

  return (
    <dialog className={`${dialogClassName} bg-superficie elev5`} id={`${id}`} data-esc="" open>
      <div className="dialog-container">
        <header className="dialog-header com-btn-fechar">
          <h5>{titulo}</h5>
          {opcaoFechar && (
            <button
              className={'btn-txt so-icone btn-fecha-dialog'}
              onClick={() => setAberto(false)}
            >
              <i className="ic-excluir"></i>
            </button>
          )}
        </header>
        {children}
      </div>
    </dialog>
  );
};
export default ModalDialog;
